export type SignatureType = 'drawn' | 'typed'

export interface SignatureTypedBody {
  type: 'typed'
  firstName: string
  lastName: string
  middleInitial: string
  drawnSignatureId?: never
  differentLegalName?: boolean
  differentNameExplanation?: string
}

export interface SignatureDrawnBody {
  type: 'drawn'
  userId: string
  drawnSignatureId: string
}

export const isDrawnSignature = (body: SignatureBody): body is SignatureDrawnBody =>
  body.type === 'drawn'

export type SignatureBody = SignatureTypedBody | SignatureDrawnBody

export interface Signature {
  cryptoKeyVersion: string
  hash: string
  timestamp: number
  userId: string
  body: SignatureBody
  date: string
}

export interface Initials {
  cryptoKeyVersion: string
  hash: string
  timestamp: number
  userId: string
  value: string
  date: string
}

export type WithoutHash<T extends Initials | Signature> = Omit<
  T,
  'hash' | 'cryptoKeyVersion' | 'timestamp' | 'userId'
>
